// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Eventos_ListResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /avaliacoes/eventos/list
 *
 * dados is an object with two keys:
 *   - events:   the list of evaluation events (one Eventos_ListRow each),
 *               sorted newest-first by event_date in the controller.
 *   - criteria: the ID-keyed criterion map built by
 *               Avaliacoes_model::mapIDCriteria() — same shape as the
 *               listCriteria endpoint, so it reuses Eventos_ListCriteriaRow.
 *
 * Both collections are owned by the external avaliacoesApi service; in the
 * local/dev environment that service is not wired, so both are empty.
 */
import type { Eventos_ListCriteriaRow } from './Eventos_ListCriteriaRow'
import type { Eventos_ListRow } from './Eventos_ListRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Eventos_ListResponseDados {
events: Eventos_ListRow[]
criteria: Record<string, Eventos_ListCriteriaRow>
}

export type Eventos_ListResponse = ApiResponse<Eventos_ListResponseDados>;

registerResponseContract('Eventos_ListResponse', {
  events: {
    type: 'array',
    required: true,
    items: {
      ID:          { type: 'string',  required: false },
      event_id:    { type: 'string',  required: false },
      event_date:  { type: 'string',  required: false },
      chat_name:   { type: 'string',  required: false },
      device_key:  { type: 'string',  required: false },
      platform:    { type: 'string',  required: false },
      event_title: { type: 'string',  required: false },
      level:       { type: 'string',  required: false },
      source_ids:  { type: 'array',   required: false },
    },
  },
  criteria: { type: 'object',  required: true },
})
